import * as $p5js_gleam from "../p5js_gleam/p5js_gleam.mjs";
import * as $p5 from "../p5js_gleam/p5js_gleam/bindings.mjs";
import { CustomType as $CustomType } from "./gleam.mjs";
import * as $utils from "./utils.mjs";
import * as $vector from "./vector.mjs";

/**
 * Represents a fired bullet.
 */
export class Bullet extends $CustomType {
  constructor(position, velocity, belongs_to_player, time_spawned) {
    super();
    this.position = position;
    this.velocity = velocity;
    this.belongs_to_player = belongs_to_player;
    this.time_spawned = time_spawned;
  }
}
export const Bullet$Bullet = (position, velocity, belongs_to_player, time_spawned) =>
  new Bullet(position, velocity, belongs_to_player, time_spawned);
export const Bullet$isBullet = (value) => value instanceof Bullet;
export const Bullet$Bullet$position = (value) => value.position;
export const Bullet$Bullet$0 = (value) => value.position;
export const Bullet$Bullet$velocity = (value) => value.velocity;
export const Bullet$Bullet$1 = (value) => value.velocity;
export const Bullet$Bullet$belongs_to_player = (value) =>
  value.belongs_to_player;
export const Bullet$Bullet$2 = (value) => value.belongs_to_player;
export const Bullet$Bullet$time_spawned = (value) => value.time_spawned;
export const Bullet$Bullet$3 = (value) => value.time_spawned;

const time_alive = 400;

const bullet_size = 6.0;

const bullet_speed = 5.0;

/**
 * The amount of damage a bullet fired by the player does.
 */
export const player_damage = 10;

/**
 * The amount of damage a bullet fired by an enemy does.
 */
export const enemy_damage = 5;

const player_bullet = "#3030ff";

const enemy_bullet = "#f4424b";

/**
 * Advances a bullet forward.
 */
export function advance_bullet(bullet) {
  return new Bullet(
    $vector.add(bullet.position, bullet.velocity),
    bullet.velocity,
    bullet.belongs_to_player,
    bullet.time_spawned,
  );
}

/**
 * Should the bullet be alive.
 */
export function is_still_alive(bullet) {
  return (bullet.time_spawned + time_alive) > $utils.now_in_milliseconds();
}

/**
 * Checks if the object at the given position with given radius collides with the bullet.
 */
export function collides_with(bullet, position, size) {
  return $vector.distance(bullet.position, position) < ((size / 2.0) + (bullet_size / 2.0));
}

/**
 * Spawns a bullet at the given position going in the given direction.
 */
export function spawn_bullet(position, direction, belongs_to_player) {
  return new Bullet(
    position,
    $vector.multiply($vector.normalize(direction), bullet_speed),
    belongs_to_player,
    $utils.now_in_milliseconds(),
  );
}

/**
 * Renders the bullet to the screen.
 */
export function draw(p, bullet) {
  $p5.no_stroke(p);
  let $ = bullet.belongs_to_player;
  if ($) {
    $p5.fill(p, player_bullet)
  } else {
    $p5.fill(p, enemy_bullet)
  }
  return $p5.circle(p, bullet.position.x, bullet.position.y, bullet_size);
}
